export default __webpack_public_path__ + "static/media/Tear of the Sadist.2a564387.jpg";